import React from 'react';
import { FormattedMessage } from '../../../util/reactIntl';
import { EmptyState, IconSearch, NamedLink } from '../../../components';

import css from './NoSearchResultsMaybe.module.css';

const NoSearchResultsMaybe = props => {
  const { listingsAreLoaded, totalItems, location, resetAll, showCreateListingsLink } = props;
  const hasNoResult = listingsAreLoaded && totalItems === 0;
  const hasSearchParams = location.search?.length > 0;

  return hasNoResult ? (
    <EmptyState
      className={css.root}
      icon={<IconSearch />}
      title={<FormattedMessage id="SearchPage.noResultsTitle" />}
      subtext={<FormattedMessage id="SearchPage.noResults" />}
    >
      {hasSearchParams ? (
        <button type="button" onClick={e => resetAll(e)}>
          <FormattedMessage id="SearchPage.resetAllFilters" />
        </button>
      ) : null}
      {showCreateListingsLink ? (
        <NamedLink name="NewListingPage">
          <FormattedMessage id="SearchPage.createListing" />
        </NamedLink>
      ) : null}
    </EmptyState>
  ) : null;
};

export default NoSearchResultsMaybe;
